<template>
  <div class="groupShopSubmitPage" >
    <div class="pageContent">
      <XR-head titleText="订单确认" :rightShow="true" ref="headObj"></XR-head>

        <div class="shopRow" >          
          <div class="shopName">
            <span>{{productInfo.ShopName}}</span>
            <i class="fa fa-angle-right"></i>
          </div>      
        </div>    
        <div class="pro-list">
          <div class="pro-item" >  
            <div class="pro-img">
              <img :src="productInfo.ImgList && productInfo.ImgList.length>0?productInfo.ImgList[0].ImgPath: IMGServer_URL+'/images/index-item-default.png'" class="img" />
            </div>
            <div class="pro-info" :style="{width:cartItemProductInfoWidth+'px'}">
              <div class="pro-row">
                <p class="pro-name">
                  <span class="groupShop">拼团</span>
                  {{productInfo.ProductName}} {{productInfo.AttrName}}
                </p>
                <div class="group-price">
                    <p class="discount-price">拼团价 <i class="fa fa-rmb"></i>{{pinTuanInfo.Fprice}}</p>
                    <p class="day-price">日销价 <span><i class="fa fa-rmb"></i>{{productInfo.SalePrice}}</span></p>
                </div>
              </div>
              <div class="pro-attr">
                <p class="delivery-time">
                  现货2个工作日内
                </p>
                <!-- <p  class="post-price">免运费</p> -->
              </div>
              <div class="pro-num">
                <div class="count">x{{orderInfo.count}}</div>
              </div>
            </div>
          </div>
        </div>      
      
      <div class="choose-info delivery"  @click="open('delivery')">
        <div class="info left">
          <div class="choose-row title">选择配送</div>
        </div>    
        <div :class="'goIcon '+(shippingMethodInfo.id!=3?'wuliu':'')">
          <i class="fa fa-angle-right"></i>
        </div> 
        <div class="info center" >
           <div class="choose-row">{{shippingMethodName}}</div>   
          <div class="choose-row" v-if="shippingDateName">{{shippingDateName}}</div>        
        </div>
        <mu-popup position="bottom" popupClass="groupShopSubmitPage-popupLayer delivery" :open="deliveryPopup" @close="close('delivery')">
          <mu-sub-header >请选择送货方式</mu-sub-header>
          <div class="deliveryChoose">
            <template v-for="methodItem in shippingMethodList">
              <mu-raised-button :label="methodItem.method"  :class="shippingMethodInfo.id==methodItem.Id?'shippingBtn select':''" @click="selectShippingMethod(methodItem.Id,methodItem.method)"></mu-raised-button>
            </template>
            <mu-raised-button label="自提" :class="shippingMethodInfo.id==3?'shippingBtn select':''" @click="selectShippingMethod(3,'自提')" v-if="isZiTiProduct|| isZiTiService"></mu-raised-button>
          </div>
          <mu-sub-header v-if="shippingMethodInfo.id != 3 ">请选择送货时间</mu-sub-header>
          <div class="dateChoose" v-if="shippingMethodInfo.id== 3">
            <div class="dateleft">
              
            </div>
          </div>
          <div class="deliveryChoose" v-else>
            <template v-for="dateItem in shippingDateList" >
              <mu-raised-button  :label="dateItem.method" :class="shippingDateInfo.id==dateItem.Id?'shippingBtn select':''" @click="selectShippingDate(dateItem.Id,dateItem.method)"></mu-raised-button>
            </template>
          </div>
          <mu-raised-button primary @click="choseDelivery(1)" fullWidth class="delvieryChooseBtn" label="确定"/>
        </mu-popup>
      </div>
      <router-link to="/usercenter/address?redirecturl=/usercenter/address">
        <div class="receive-address" v-if="shippingMethodInfo.id != 3 ">          
          <div class="mapIcon">
            <i class="fa fa-location"></i>
          </div>
          <div class="address-info" :style="{width:addressInfoWidth+'px'}">
            <div class="contract">
              <span class="name">{{receiveAddress.Receiver}}</span>
              <span class="mobile">{{receiveAddress.Phone}}</span>
            </div>
            <div class="address-content">
              <span class="text">{{receiveAddress.DetailAddress}}</span>
            </div>
          </div>
          <div class="goIcon">
            <i class="fa fa-angle-right"></i>
          </div>
        </div>
        <div class="addressBar"></div>
        <div class="addressBar"></div>
      </router-link>

      <div class="choose-info">
        <div class="info left">
          <div class="choose-row title">发票</div>
        </div>   
        <div class="info center" :style="{width:chooseInfoWidth+'px'}">
          <div class="choose-row"><mu-switch v-model="isFapiao" /></div>
          <div class="choose-row">{{orderInfo.fapiao ? '抬头：'+orderInfo.fapiao:''}}</div>
        </div>
        <mu-popup position="bottom" popupClass="groupShopSubmitPage-popupLayer fapiao" :open="fapiaoPopup" @close="close('fapiao')">
          <div class="deliveryChoose">
            <mu-text-field fullWidth label="发票抬头" hintText="请输入发票抬头" helpText="抬头不能超过25个汉字" v-model="orderInfo.fapiao" :maxLength="25" />
          </div>
          <mu-raised-button primary @click="closeChoose('fapiao')" fullWidth class="delvieryChooseBtn" label="确定"/>
        </mu-popup>
      </div>
      <div class="choose-info integral">
        <div class="info left">
          <div class="choose-row title">BAW</div>
          <div class="choose-row">余额：<span>{{bawCount.toFixed(6)}}</span></div>
          <div class="choose-row balance">可抵扣：<span>{{bawTotalPrice}}BAW</span></div>
        </div>
        <div class="info center" :style="{width:chooseInfoWidth+'px'}">
          <div class="choose-row"><mu-switch v-model="isBaw" /></div>
          <div class="choose-row">{{isBaw?'已使用'+orderInfo.baw.toFixed(6)+'BAW':'无'}}</div>

          <div class="choose-row integralModify" v-if="isBaw" @click="bawPopup=true">修改</div>
          <div class="choose-row" v-if="!isBaw" >&nbsp;</div>
        </div>
        <!-- <div class="goIcon">
          <i class="fa fa-angle-right"></i>
        </div> -->
        <mu-popup position="bottom" popupClass="groupShopSubmitPage-popupLayer integral" :open="bawPopup">
          <div class="deliveryChoose">
            <mu-text-field fullWidth label="请输入要抵扣的BAW" :errorText="bawErrorText"  type="number" labelFloat v-model="baw" />
          </div>
          <mu-raised-button primary @click="closeChoose('baw')" fullWidth class="delvieryChooseBtn" label="确定"/>
        </mu-popup>
      </div>

      <div class="remark">
        <mu-text-field label="留言" hintText="最长不超过50个字符" v-model="orderInfo.liuyan" fullWidth multiLine :rows="1" :rowsMax="6" helpText="选填:给商家留言" :errorText="multiLineInputErrorText" @textOverflow="handleMultiLineOverflow" :maxLength="50"/>
      </div>

      <div class="price-info">
        <div class="row">
          <p class="title" style="font-weight: bold;">商品金额</p>
          <p class="price" style="font-weight: bold;">
            <i class="fa fa-rmb"></i>
            <span>{{pinTuanInfo.Fprice*orderInfo.count}}</span>
          </p>
        </div>
        <div class="row">
          <p class="title">运费</p>
          <p class="price">
            <span>+</span>
            <i class="fa fa-rmb"></i>
            <span>{{freightPrice}}</span>
          </p>
        </div>
        <!-- <div class="row">
          <p class="title">积分抵扣</p>
          <p class="price">
            <span>-</span>
            <i class="fa fa-rmb"></i>
            <span>{{integral}}.00</span>
          </p>
        </div> -->
        <div class="row">
          <p class="title">BAW抵扣</p>
          <p class="price">
            <span>-</span>
            <i class="fa fa-rmb"></i>
            <span>{{bawDiscountTotalPrice}}</span>
          </p>
        </div>
      </div>

      <mu-divider />
      <div class="bottom-bar">
        <mu-row >
          <mu-col width="65" tablet="65" desktop="65">
            <p class="cart-total">
              <span>实付款：<i class="fa fa-rmb"></i></span>
              <span class="money">{{pinTuanInfo.Fprice*orderInfo.count+freightPrice-bawDiscountTotalPrice}}</span>
            </p>
          </mu-col>
          <mu-col width="35" tablet="35" desktop="35">
            <mu-flat-button label="提交订单" class="gobuy" :disabled="disabled" backgroundColor="red" color="white" fullWidth @click="orderSubmit" />
          </mu-col>
        </mu-row>
      </div>
    </div>
    <XR-toast @onClose="submitSuccess" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import cart from '../../util/cart'
export default {
  data () {
    return {
      fullWidth: (parseInt(document.documentElement.clientWidth)-20) ,
      cartItemProductInfoWidth: (parseInt(document.documentElement.clientWidth)-100),
      addressInfoWidth: (parseInt(document.documentElement.clientWidth)-70) ,
      chooseInfoWidth: (parseInt(document.documentElement.clientWidth)-190) ,      
      deliveryPopup: false,
      disabled:false,
      fapiaoPopup: false,
      integralPopup: false,
      bawPopup: false,
      isFapiao: false,
      isIntegral: false,
      integral:'',
      isBaw: false,
      baw:'',
      memberIntegral:0,
      integralTotalPrice:0,
      bawTotalPrice:0,
      bawDiscountTotalPrice:0,
      productInfoList:[],
      receiveAddress :{},
      totalPrice : 0,
      totalPayPrice : 0,
      shippingMethodInfo:{id:0,name:''},
      shippingDateInfo:{id:0,name:''},
      shippingMethodName:'',
      shippingDateName:'',
      orderInfo:{
        skuId: this.$route.query.skuId,
        activityId: this.$route.query.activityId,
        groupId: this.$route.query.groupId,
        count:this.$route.query.count,
        isBaw:0,
        bawDiscount:0.000000,
        pintuanPrice:0,
        fapiao:'',
        liuyan:'',
        receiverId:0,
        shippingMethodId:0,
        shippingDateId:0,
        guid:0,
      },
      bottomPopup: false,
      shippingMethodList:[],
      shippingDateList:[],
      orderNos:[],
      freightPrice: 0,      
      multiLineInputErrorText:'',
      skuId:this.$route.query.skuId,
      selfPickUpShopInfo:{},
      selfPickUpDateList:[],
      selfPickUpDate1:'',
      selfPickUpDate2:'',
      isZiTiProduct:false,
      isZiTiService:false,
      shopInfo:{},
      loaded:false,
      integralErrorText:'', 
      bawErrorText:'',      
      bawCount:0.000000,
      bawRate:0.000000,
      productShowList:[],
      orderNumber:'',
      productInfo:{},
      pinTuanInfo:{},
    }
  },
  mounted:function(){
    this.getGuid()
    this.getShippingDateList()
    this.getShippingMethodList()
    this.getDefaultAddress()
    this.getProductDetail()
  },
  methods: {
    getGuid(){
      var Atanisi = Math.floor(Math.random() * 9999);

    var myDate = new Date();
    var tY = myDate.getFullYear();
    var tM = myDate.getMonth()+1;
    if (tM >= 1 && tM <= 9) {
          tM = "0" + tM;
      }
    var tD = myDate.getDate();
    if (tD >= 1 && tD <= 9) {
          tD = "0" + tD;
      }
    var tH = myDate.getHours();    
    if (tH >= 1 && tH <= 9) {
          tH = "0" + tH;
      }
    var tm = myDate.getMinutes();   
     if (tm >= 1 && tm <= 9) {
        tm = "0" + tm;
    }
    var tS = myDate.getSeconds();  
      if (tS >= 1 && tS <= 9) {
        tS = "0" + tS;
    }
    this.orderInfo.guid = tM+tD+tH+tm+tS+Atanisi
    },
    open (obj) {
      this[obj+'Popup'] = true
      if(obj == 'delivery'){
        this.shippingMethodInfo.id = this.orderInfo.shippingMethodId
        this.shippingMethodInfo.name = this.shippingMethodName
        this.shippingDateInfo.id = this.orderInfo.shippingDateId
        this.shippingDateInfo.name = this.shippingDateName
      }
      else if(obj == 'integral'){
      }
      else if(obj == 'baw'){
        this.bawPopup = true;
      }
      else if(obj == 'fapiao'){
      }
    },
    close (obj) {
      this[obj+'Popup'] = false
      if(obj == 'integral'){
        this.isIntegral = false
      }
      else if(obj == 'fapiao'){
        this.isFapiao = false
      }      
    },
    closeChoose(obj){
      if(obj == 'integral'){
        this.integralErrorText =''
        if(this.isIntegral){
          var integral = parseInt(this.integral)
          if(integral>0){
            if(integral>this.integralTotalPrice){              
              this.integralErrorText ='积分超过可抵扣值'
              return
            }
            if(integral > this.memberIntegral.Integral){  
              this.integralErrorText ='积分账户余额不足'            
              return
            }        
            if(this.totalPayPrice-integral<=0){
              this.integralErrorText ='订单金额不能小于0'            
              return
            }     

            this.orderInfo.isIntegral = true
            this.orderInfo.integral = integral
          }else{            
            this.integral = ''
            this.isIntegral = false
          }
        }
      }
      else if(obj == 'baw'){
        this.bawErrorText =''
        if(this.isBaw){
          var baw = parseFloat(this.baw)
          if(baw>0){
            if(baw>this.bawTotalPrice){              
              this.bawErrorText ='BAW超过可抵扣值'
              return
            }
            if(baw > this.bawCount){  
              this.bawErrorText ='BAW账户余额不足'            
              return
            }        
            if(this.totalPayPrice-baw<=0){
              this.bawErrorText ='订单金额不能小于0'            
              return
            }     

            this.orderInfo.isBaw = true
            this.orderInfo.baw = baw
            this.bawDiscountTotalPrice = (baw / this.bawRate).toFixed(2)
          }else{            
            this.baw = ''
            this.isBaw = false
            this.orderInfo.isBaw = false
            this.orderInfo.baw = 0
            this.bawDiscountTotalPrice = 0
          }
        }
      }
      else if(obj == 'fapiao'){
        if(!this.orderInfo.fapiao){
          this.isFapiao = false
        }
      }
      this[obj+'Popup'] = false
    },    
    handleMultiLineOverflow (isOverflow) {
      this.multiLineInputErrorText = isOverflow ? '不能超过50个字符' : ''
    },    
    getDefaultAddress(){
      var ths = this
      ths.$post(
        "/Shop/UserServer/GetDefaultReceiveAddress"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)   
        }else{   
          ths.$refs.XRtoast.hide()
          ths.receiveAddress = res.Data
          ths.orderInfo.receiverId = res.Data.Id
          ths.loaded = false
         
        } 
      });
      
    },       
    getShippingDateList(){
      var ths = this  
      ths.$post(
        "/Shop/RetailServer/GetShippingDateList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.shippingDateList = res.Data
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    getShippingMethodList(){   
      var ths = this 
      ths.$post(
        "/Shop/RetailServer/GetShippingMethodList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.shippingMethodList = res.Data
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    selectShippingDate(id, name){
      this.shippingDateInfo.id = id
      this.shippingDateInfo.name = name
    },
    selectShippingMethod(id, name){
      if(id==3){
        if(!(this.skuId>0)){
          this.close('delivery')
          this.$refs.XRtoast.failed('只支持单品自提', true)
          return
        }
      }

      this.shippingMethodInfo.id = id
      this.shippingMethodInfo.name = name
    },
    choseDelivery(type){
      if(type == 1){
        this.close('delivery')  
        
        if(this.shippingMethodInfo.id==0){
          
          this.$refs.XRtoast.failed('请选择送货方式', true)
          return
        }
        this.orderInfo.shippingMethodId = this.shippingMethodInfo.id
        this.shippingMethodName = this.shippingMethodInfo.name
              
        if(this.orderInfo.shippingMethodId==3){
          if(!(this.skuId>0)){
            this.$refs.XRtoast.failed('只支持单品自提', true)
            return
          }
          
          if(this.isZiTiProduct){          
            this.goSelectSelfPickUp()
          }
          else if(this.isZiTiService){
            this.selfPickUpShopInfo = this.shopInfo
            this.orderInfo.selfPickUpSiteShopId= this.shopInfo.shopId
          }
          else{
            this.$refs.XRtoast.failed('商品不支持自提', true)
            return          
          }        
        }else{     
          if(this.shippingDateInfo.id<=0){
            this.$refs.XRtoast.failed('请选择送货时间', true)
            return
          }     
          this.orderInfo.shippingDateId = this.shippingDateInfo.id
          this.shippingDateName = this.shippingDateInfo.name
        }

        this.getFreight()
      }else{
        this.close('bottom')
        this.orderInfo.selfPickUpDate = this.selfPickUpDate1+' '+this.selfPickUpDate2
      }
    },
    getFreight(){
      
      var ths = this
      ths.$post(
        "/Shop/RetailServer/GetFreightByAddressCode",
        JSON.stringify({
          provinceCode:this.receiveAddress.Province,
          cityCode: this.receiveAddress.City,
          areaCode: this.receiveAddress.Area,
          shoppingMethod: this.orderInfo.shippingMethodId,
          skus: [{skuId: this.orderInfo.skuId, count: this.orderInfo.count}]
        })
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.$refs.XRtoast.hide()
          ths.loaded = false
          ths.freightPrice = res.Data
          ths.totalPayPrice = ths.totalPrice + ths.freightPrice; 
        }
      });
    },
    getPinTuanInfo(){      
      const ths = this;
      this.$post("/Shop/PinTuanServer/WapActivityGetInfoBySku", {skuId: this.orderInfo.skuId ,activityId:this.orderInfo.activityId})
      .then(function(res) {
        if (res.IsSuccess) {   
          if(res.Data.Fskuid == ths.skuId){            
            ths.pinTuanInfo = res.Data
            ths.orderInfo.pintuanPrice = ths.pinTuanInfo.Fprice
          }else{
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getProductDetail:function(){
      if(this.orderInfo.activityId){
        this.getPinTuanInfo()
      }
      var ths = this;   
      ths.$post(
        "/Shop/RetailServer/GetProductDetail",
        JSON.stringify({skuId:this.skuId})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.productInfo = res.Data 
          var attrItemList = []
          if(ths.productInfo.AttrList){
            for(var i = 0;i<ths.productInfo.AttrList.length;i++){
              var attrItem = ths.productInfo.AttrList[i]
              if(attrItem.Values){
                for(var j = 0; j< attrItem.Values.length; j++){
                  var valueItem = attrItem.Values[j]
                  if(valueItem.IsSkuValue == 1){
                    attrItemList.push(attrItem.Name+":"+valueItem.Name)
                  }
                }
              }
            }
          }
          if(attrItemList){
            ths.productInfo.AttrName = attrItemList.join(",")
          }
        }
      });
    },
    orderSubmit(){    
      var ths = this  
      ths.orderInfo.skuFid = ths.pinTuanInfo.Fid
      if(this.shippingMethodInfo.id==0){  
        this.$refs.XRtoast.failed('请选择送货方式', true)
        return
      }
      this.orderInfo.shippingMethodId = this.shippingMethodInfo.id
      this.shippingMethodName = this.shippingMethodInfo.name
            
      if(this.orderInfo.shippingMethodId==3){
        if(!(this.skuId>0)){
          this.$refs.XRtoast.failed('只支持单品自提', true)
          return
        }
        
        if(this.isZiTiProduct){          
          this.goSelectSelfPickUp()
        }
        else if(this.isZiTiService){
          this.selfPickUpShopInfo = this.shopInfo
          this.orderInfo.selfPickUpSiteShopId= this.shopInfo.shopId
        }
        else{
          this.$refs.XRtoast.failed('商品不支持自提', true)
          return          
        }        
      }else{     
        if(this.shippingDateInfo.id<=0){
          this.$refs.XRtoast.failed('请选择送货时间', true)
          return
        }     
        this.orderInfo.shippingDateId = this.shippingDateInfo.id
        this.shippingDateName = this.shippingDateInfo.name
      }
      ths.disabled = true
      var url = '/Shop/PinTuanServer/GroupAdd';
      if(this.orderInfo.groupId>0){
        url = '/Shop/PinTuanServer/GroupJoin';
      }
      ths.$post(
        url, this.orderInfo
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.disabled = false
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{   
          ths.orderNumber = res.Data.orderNumber  
          ths.$refs.XRtoast.success(res.Msg, true)          
        }
      });
    },
    submitSuccess(){
      this.$router.push('/groupShop/orderPay?orderNumber='+this.orderNumber)
    }
  },
  watch:{
     isFapiao:function(){
      if(this.isFapiao){
        this.open('fapiao')
      }else{
        this.orderInfo.fapiao=''
      }
    },
  }
}
</script>
<style>
.groupShopSubmitPage{
  background: #F0F2F5;
  bottom: unset;
}
.pageContent{
  padding-bottom: 56px;
}

.groupShopSubmitPage .goIcon{
  width: 20px;
  float: right;
  text-align: right;
}
.groupShopSubmitPage .goIcon.wuliu{
  line-height: 48px;
}
.groupShopSubmitPage .goIcon.selfPick{
  line-height: 48px;
}

.groupShopSubmitPage .mapIcon{
  float: left;
  width: 30px;
  line-height: 40px;
}

.groupShopSubmitPage .receive-address{
  background: white;
  color:black;
  padding: 10px;
  overflow: hidden;
  margin-top: 10px;
}
.groupShopSubmitPage .addressBar{
  width: 50%;
  float: left;
  height: 3px;
  background: url('../../../static/addressbar.png');
  background-size: 100% 100%; 
}
.groupShopSubmitPage .receive-address .address-info{
  float: left;
}
.groupShopSubmitPage .receive-address .address-info .name{
  font-size:16px;
  font-weight: 700;
  padding-right: 15px;
}
.groupShopSubmitPage .receive-address .address-info .mobile{
  font-size:16px;
  font-weight: 700;
}
.groupShopSubmitPage .receive-address .address-info .address-content{
  font-size:12px;
  line-height: 18px;
  color:#999;
}
.groupShopSubmitPage .receive-address .address-info .address-content .fa{
  width: 20px;
}
.groupShopSubmitPage .receive-address .goIcon{
  line-height: 40px;
}

.groupShopSubmitPage .choose-info{
  overflow: hidden;
  padding:10px;
  background: white;
  margin-top: 10px;
}
.groupShopSubmitPage .choose-info .info{
  font-size: 12px;
  float: left;
  line-height: 24px;
}
.groupShopSubmitPage .choose-info .info.center{
  float: right;
}
.groupShopSubmitPage .choose-info .info.left {
 
}
.groupShopSubmitPage .choose-info .info.left .title{
  font-size: 14px;
  font-weight: 700;
}
.groupShopSubmitPage .choose-info .info .choose-row{
  line-height: 24px;
  font-size: 14px;
}
.groupShopSubmitPage .choose-info .info.center .choose-row{
  text-align: right;
}
.groupShopSubmitPage .choose-info.integral .info.left .choose-row.balance{
  color:red;
}
.groupShopSubmitPage .choose-info.integral .info.center .choose-row.integralModify{
  color:red;
}
.groupShopSubmitPage .info.center .choose-row.ziti{
  float: left;
}

.groupShopSubmitPage .remark{
  background: white;
  margin-top: 10px;
  padding:10px 10px 0;
}
.groupShopSubmitPage .remark .mu-text-field-label{
  font-size: 18px;
}
.groupShopSubmitPage .price-info{
  background: white;
  margin-top: 10px;
  padding:10px 10px 40px;
}
.groupShopSubmitPage .price-info .row{
  background: white;
  overflow: hidden;
  line-height: 32px;
}
.groupShopSubmitPage .price-info .row .title{
  font-size: 14px;
}
.groupShopSubmitPage .price-info .row .price{
  color:Red;
}


.groupShopSubmitPage .shopRow{
  background: #F8F8F8;
  overflow: hidden;
  color:#666;
  width: 100%;
  line-height: 40px;
  height: 40px;
  border-top:#ddd solid 1px;
}
.groupShopSubmitPage .shopRow .all-chk{
  float: left;
  width: 40px;
  margin-top: 6px;
  text-align: center;
}
.groupShopSubmitPage .shopRow .shopName{
  padding-left: 10px;
}


.groupShopSubmitPage .pro-list{
  background: white;
  overflow: hidden;
}
.groupShopSubmitPage .pro-list .pro-item{
  padding: 16px 0;
  overflow: hidden;
}
.groupShopSubmitPage .pro-list .pro-item .pro-img{
  width: 80px;
  float: left;
}
.groupShopSubmitPage .pro-list .pro-item .pro-img img{
  width: 100%;
  display: block;
  border-radius: 4px;
  margin: 0 10px;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info{
  float: right;
  padding-right: 10px;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-row{
  overflow: hidden;
  padding: 2px;

}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-row .pro-name{
  font-size: 12px;
  line-height: 20px;
  height: 40px;
  padding: 3px;
  overflow: hidden;
  float: left;
  width: 60%;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-row .pro-name .groupShop{
  border: 1px solid red;
  border-radius: 3px 3px;
  padding: 1px 3px;
  font-size: 12px;
  color: red;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-row .group-price{
  float: right;
  width: 40%;
  text-align: right;
  font-size: 14px;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-row .group-price .discount-price{
  color: red;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-row .group-price .discount-price .fa-rmb{
  font-size: 12px;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-row .group-price .day-price{
  font-size: 12px;
  text-align: right;
  color: #999;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-row .group-price .day-price span{
  text-decoration: line-through;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-attr{
  font-size: 12px;
  line-height: 25px;
  height: 25px;
  color:#999;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-attr .delivery-time{
  float: left;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-attr .post-price{
  float: right;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-num{
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color:#999;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-num .pro-price{
  font-size: 16px;
  line-height: 16px;
  float: left;
  color:red;
}
.groupShopSubmitPage .pro-list .pro-item .pro-info .pro-num .count{
  font-size: 12px;
  line-height: 16px;
  color:#999;
  float: right;
}




.groupShopSubmitPage .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  height: 56px;
  border-top:1px solid #eee;
  z-index: 9999;
}
.groupShopSubmitPage .bottom-bar .cart-total{
  float: left;
  height: 56px;
  line-height: 56px;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 700;
  color:Red;
}
.groupShopSubmitPage .gobuy{
  width: 100%;
  line-height: 56px;
  height: 56px;
  text-align: center;
}

.groupShopSubmitPage-popupLayer {
  width: 100%;
  min-height: 120px;
}
.groupShopSubmitPage-popupLayer .deliveryChoose {
  padding: 0 10px;
}
.groupShopSubmitPage-popupLayer .delvieryChooseBtn{
  margin: 40px 0 0;
  height: 50px; 
}

.groupShopSubmitPage-popupLayer .shippingBtn.select{
  background: red;
  color:white;
}
.groupShopSubmitPage-popupLayer .dateChoose{
  padding: 0 10px;
  display: flex;
}
.dateChoose .dateleft{
width: 50%;
}
.dateChoose .daterigth{
  width: 50%;
  text-align: right;
  text-align: -webkit-right;
}
.dateChoose .active{
  background: red;
  color:white;
}
.dateChoose .daterigth .mu-raised-button{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/groupShop/groupShopSubmit.vue